import React from 'react'

import './CaseBodyFooter.css'

const FooterButtonLeftSection = (props) => (
  <div className="gdocs-float-left gdocs-flex-1">
    {props.children}
  </div>
)

const FooterButtonRightSection = (props) => (
  <div className="gdocs-float-right">
    {props.children}
  </div>
)

export { FooterButtonLeftSection , FooterButtonRightSection }

const FooterButtonSection = (props) => (
  <div className={`gdoc-footer-button-section-container ${props.bsClass}`}>
    {props.children}
  </div>
)


export default FooterButtonSection;



// WEBPACK FOOTER //
// ./src/components/common/CaseBodyFooter/index.js